import _ from 'lodash';
import { BaseItem, Gender } from './common';
import { Specialty } from './encounter';
import { LanguageWithOther } from './previsit/language';

export enum EducationKind {
  Undergraduate = 'UNDERGRADUATE',
  Graduate = 'GRADUATE',
  MedicalSchool = 'MEDICAL_SCHOOL',
  Residency = 'RESIDENCY',
  Fellowship = 'FELLOWSHIP',
}

export const EducationKindMap: {
  [education in EducationKind]: string;
} = {
  UNDERGRADUATE: 'Undergraduate',
  GRADUATE: 'Graduate',
  MEDICAL_SCHOOL: 'Medical School',
  RESIDENCY: 'Residency',
  FELLOWSHIP: 'Fellowship',
};

export type Education = {
  institution: string;
  kind: EducationKind;
  yearEnded?: string;
};

export const EDUCATION_TO_EDUCATION_KIND = _.invert(EducationKindMap);

export type Position = {
  name: string;
  organization?: string;
  location?: string;
  years?: string;
};

export type Certification = {
  certification: string;
  institution?: string;
  year?: string;
};

export type ProfessionalMembership = {
  name: string;
};

export type Publication = {
  publication: string;
  publisher?: string;
  year?: string;
};

export type Award = {
  award: string;
  sponsor?: string;
  year?: string;
};

interface FullProfile {
  about: string;
  carePhilosophy: string;
  areasOfInterest: string;
  gender: Gender;
  pronouns: string;
  spokenLanguages: LanguageWithOther[];
  jobTitle: string;
  specialties: Specialty[];
  specialtiesRaw: string[];
  education: Education[];
  positions: Position[];
  certifications: Certification[];
  professionalMemberships: ProfessionalMembership[];
  publications: Publication[];
  awards: Award[];
}

export type Profile = Partial<FullProfile>;

export interface BaseProviderProfile {
  providerUserId: string;
  profile: Profile;
}

export interface ProviderProfile extends BaseItem, BaseProviderProfile {}
